export default __webpack_public_path__ + "static/media/whatsapp.983ba984.svg";